// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ScoreSliderPin from "./ScoreSliderPin.bs.js";
import * as ScoreSliderTrack from "./ScoreSliderTrack.bs.js";
import * as ScoreSliderValueBox from "./ScoreSliderValueBox.bs.js";

function ScoreSlider(Props) {
  var current_score = Props.current_score;
  var min_score = Props.min_score;
  var max_score = Props.max_score;
  var threshold_values = Props.threshold_values;
  return React.createElement("div", {
              className: "slider-container"
            }, React.createElement(ScoreSliderValueBox.make, {
                  current_score: current_score,
                  min_score: min_score,
                  max_score: max_score,
                  threshold_values: threshold_values
                }), React.createElement(ScoreSliderPin.make, {
                  current_score: current_score,
                  min_score: min_score,
                  max_score: max_score
                }), React.createElement(ScoreSliderTrack.make, {
                  threshold_values: threshold_values
                }));
}

var make = ScoreSlider;

export {
  make ,
  
}
/* react Not a pure module */
